// Hand-written ABI for Gaia.sol. Kept in sync with packages/contracts/contracts/Gaia.sol.

export const gaiaAbi = [
  // ---- mint ----
  { type: "function", name: "mint", stateMutability: "payable", inputs: [], outputs: [] },
  { type: "function", name: "batchMint", stateMutability: "payable", inputs: [{ name: "count", type: "uint256" }], outputs: [] },

  // ---- ops ----
  {
    type: "function",
    name: "flushLP",
    stateMutability: "nonpayable",
    inputs: [
      { name: "ethAmount", type: "uint256" },
      { name: "tokenAmount", type: "uint256" },
      { name: "liquidity", type: "uint256" },
      { name: "deadline", type: "uint256" },
    ],
    outputs: [],
  },
  {
    type: "function",
    name: "claimFees",
    stateMutability: "nonpayable",
    inputs: [{ name: "deadline", type: "uint256" }],
    outputs: [],
  },

  // ---- constants ----
  { type: "function", name: "MINT_PRICE",          stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "TOKENS_PER_MINT",     stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "MAX_MINTS_PER_USER",  stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "MAX_TOTAL_MINTS",     stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "PROFIT_CAP",          stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "LP_FLUSH_THRESHOLD",  stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "INITIAL_SUPPLY",      stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "MINT_RESERVE",        stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "LP_RESERVE",          stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "PROFIT_WALLET",       stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },

  // ---- counters ----
  { type: "function", name: "totalMints",            stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalProfitSent",       stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalLPRoutedETH",      stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalLPFlushedETH",     stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalFeesClaimedETH",   stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "totalFeesClaimedGAIA",  stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "lpReserveETH",          stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "mintingPaused",         stateMutability: "view", inputs: [], outputs: [{ type: "bool" }] },

  // ---- views ----
  { type: "function", name: "currentPhase",         stateMutability: "view", inputs: [], outputs: [{ type: "uint8" }] },
  { type: "function", name: "profitRemaining",      stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "mintsRemaining",       stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "userMintsRemaining",   stateMutability: "view", inputs: [{ name: "u", type: "address" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "mintPoolRemaining",    stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "v4PositionManager",    stateMutability: "view", inputs: [], outputs: [{ type: "address" }] },
  { type: "function", name: "v4PositionTokenId",    stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },

  // ---- ERC20 ----
  { type: "function", name: "name",        stateMutability: "view", inputs: [], outputs: [{ type: "string" }] },
  { type: "function", name: "symbol",      stateMutability: "view", inputs: [], outputs: [{ type: "string" }] },
  { type: "function", name: "decimals",    stateMutability: "view", inputs: [], outputs: [{ type: "uint8" }] },
  { type: "function", name: "totalSupply", stateMutability: "view", inputs: [], outputs: [{ type: "uint256" }] },
  { type: "function", name: "balanceOf",   stateMutability: "view", inputs: [{ name: "a", type: "address" }], outputs: [{ type: "uint256" }] },
  { type: "function", name: "mintsBy",     stateMutability: "view", inputs: [{ name: "a", type: "address" }], outputs: [{ type: "uint256" }] },

  // ---- events ----
  {
    type: "event",
    name: "Minted",
    inputs: [
      { name: "minter", type: "address", indexed: true },
      { name: "tokenAmount", type: "uint256", indexed: false },
      { name: "ethPaid", type: "uint256", indexed: false },
      { name: "mintNumber", type: "uint256", indexed: false },
    ],
  },
  {
    type: "event",
    name: "LPFlushReady",
    inputs: [{ name: "reserve", type: "uint256", indexed: false }],
  },
] as const;
